<div class="ws-category-nav__mobile"
     [class.ws-category-nav__mobile--sticky]="isSticky">
  <div class="ws-category-nav__mobile-list" #container>
    @for (category of categories; track category.id) {
      <button class="ws-category-nav__item ws-category-nav__item--mobile"
              [id]="idPrefix + category.id"
              [class.ws-category-nav__item--active]="category.id === highlightedCategory?.id"
              (click)="selectCategory(category)">
        {{category.name}}
      </button>
    }

    <div class="ws-category-nav__mobile-end"></div>
  </div>
</div>
